@switch (cardType) {
	@case (cardTypes.VERTICAL) {
		<ng-container *ngTemplateOutlet="CategoryCardVertical"></ng-container>
	}
	@case (cardTypes.HORIZONTAL) {
		<ng-container *ngTemplateOutlet="CourseHorizontalCard"></ng-container>
	}
	@case (cardTypes.SHOP_CART) {
		<ng-container *ngTemplateOutlet="shopCartCard"></ng-container>
	}
	@case (cardTypes.ONLY_THUMBNAIL) {
		<ng-container *ngTemplateOutlet="onlyThumbnailCard"></ng-container>
	}
}

<ng-template #onlyThumbnailCard>
	<div class="pointer w-100 h-100">
		@if (category?.video && overviewCourse) {
			<app-video-player
			customClass="no-radius"
			[thumbnail]="category?.videoThumbnail"
			[videoUrl]="category?.video"
			[videoId]="null">
			</app-video-player>
		} @else {
			<app-image [src]="category?.image" [imageResolutions]="[IMAGE_RESOLUTIONS.im, IMAGE_RESOLUTIONS.lg]" placeholder="../../../assets/images/thumbnail.png" width="100%" height="100%" [fitCover]="true"></app-image>
		}
	</div>
</ng-template>

<ng-template #CategoryCardVertical>
	<div class="bg-accent-lighter card storeCard pointer" [ngClass]="{'overviewCard': overviewCourse}" (click)="overviewCategory(category)">
		<div class="height-img">
			@if (category?.video && overviewCourse) {
				<app-video-player
				customClass="no-radius"
				[thumbnail]="category?.videoThumbnail"
				[videoUrl]="category?.video"
				[videoId]="null">
				</app-video-player>
			} @else {
				<app-image [src]="category?.image" [imageResolutions]="[IMAGE_RESOLUTIONS.im, IMAGE_RESOLUTIONS.lg]" placeholder="../../../assets/images/thumbnail.png" [fitCover]="true" borderRadius="7px 7px 0 0" [height]="overviewCourse ? '100%' : '171px'"></app-image>
			}
		</div>
		<div class="vertical-course-info-container" [ngClass]="{'gap-8': overviewCourse}">
			@if (!overviewCourse) {
				<p class="text-accent-darker">{{category?.author}}</p>
			}
			<div class="title-container pb-6">
				 @if (overviewCourse) {
					<h5 class="title truncate-title text-accent-darker">{{'general.course_information' | translateWithKeys}}</h5>
				 } @else {
					<h5 class="title truncate-title text-accent-darker">{{category?.name | customTitleCase}}</h5>
				 }
			</div>
			<div class="store-course-info">
				<ng-container *ngTemplateOutlet="overviewCourse ? overviewCategoryInfo : storeCategoryInfo"></ng-container>
			</div>
			<div class="price-container">
				@if (overviewCourse) {
					<h4 class="text-accent-darker">{{category?.currency?.label}}&nbsp;{{category?.price | currency:null:'symbol':'0.0-2' | truncate:20 }}</h4>
				} @else {
					<p class="text-accent-darker"><b>{{category?.currency?.label}}&nbsp;{{category?.price | currency:null:'symbol':'0.0-2' | truncate:20 }}</b></p>
				}
			</div>
			<div>
				<div class="vertical-btns-container w-100">
					<button class="store-card-btn bg-primary-darker text-accent-lighter" mat-flat-button (click)="executeCategoryAction(action); $event.stopImmediatePropagation()">
						@if(action != CategoryCardAction.ENROLLED) {
							<mat-icon class="shop-cart" svgIcon="shopping_cart"></mat-icon>
						}
						@switch (action) {
							@case (CategoryCardAction.AVAILABLE) {
								{{'explore.add_to_cart' | translateWithKeys}}
							}
							@case (CategoryCardAction.IN_CART) {
								{{'explore.go_to_cart' | translateWithKeys}}
							}
							@case (CategoryCardAction.ENROLLED) {
								{{'explore.go_to_course' | translateWithKeys}}
							}
						}
					</button>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #CourseHorizontalCard>
	<div class="bg-accent-lighter card horizontal-store-card pointer">
		<div class="flex row gap-16">
			<div>
				<app-image customClass="radius-10" [imageResolutions]="[IMAGE_RESOLUTIONS.im, IMAGE_RESOLUTIONS.lg]" [src]="course?.image" placeholder="../../../assets/images/thumbnail.png" width="140px" height="80px" [fitCover]="true"></app-image>
			</div>
			<div class="course-info-container p-0">
				<div class="title-container limit-height h-100">
					<div class="flex row title-horizontal start w-100">
						<h2 class="title truncate-2 text-accent-darker">{{course?.name | customTitleCase}}</h2>
					</div>
					<div class="store-course-info">
						<ng-container *ngTemplateOutlet="storeCourseInfo"></ng-container>
					</div>
				</div>
			</div>
		</div>
		<div class="height-description-horizontal">
			<p class="text-accent-darker">{{course?.description}}</p>
		</div>
	</div>
</ng-template>

<ng-template #storeCourseInfo>
	<div class="chapters">
		<mat-icon class="text-accent" svgIcon="courses"></mat-icon>
		<p class="text-accent max-content">{{course?.totalChapters}} {{(course?.totalChapters == 1 ? 'general.chapter' : 'general.chapters') | translateWithKeys}}</p>
	</div>
	<div class="duration">
		<mat-icon class="text-accent" svgIcon="media"></mat-icon>
		<p class="text-accent .w-80">{{course?.totalMinutes | timeFormat}}</p>
	</div>
</ng-template>

<ng-template #storeCategoryInfo>
	<div class="chapters">
		<mat-icon class="text-accent" svgIcon="courses"></mat-icon>
		<p class="text-accent max-content">{{category?.courses?.length}} {{(category?.courses?.length == 1 ? 'general.content' : 'general.contents') | translateWithKeys}}</p>
	</div>
	<div class="duration">
		<mat-icon class="text-accent" svgIcon="media"></mat-icon>
		<p class="text-accent .w-80">{{category?.duration | timeFormat}}</p>
	</div>
</ng-template>

<ng-template #overviewCategoryInfo>
	<div class="flex column gap-16">
		<div class="chapters">
			<mat-icon class="text-accent-darker" svgIcon="courses"></mat-icon>
			<p class="text-accent-darker">{{category.courses.length}} {{(category.courses.length == 1 ? 'general.content' : 'general.contents') | translateWithKeys}}</p>
		</div>
		<div class="duration">
			<mat-icon class="text-accent-darker" svgIcon="media"></mat-icon>
			<p class="text-accent-darker">{{category?.duration | timeFormat}}</p>
		</div>
		<div class="languages">
			<mat-icon class="text-accent-darker" svgIcon="world_black"></mat-icon>
			<div class="flex row g-4">
				<p class="text-accent-darker">{{'general.languages' | translateWithKeys}}:</p>
				@for (language of category?.languages; track $index) {
					<p class="text-accent-darker">{{language.name | translateWithKeys}}</p>
				}
			</div>
		</div>
		<div class="flex gap-8">
			<mat-icon class="text-accent-darker" svgIcon="calendar"></mat-icon>
			<p class="text-accent-darker">{{'general.updated' | translateWithKeys}}: {{category?.updatedAt?.seconds *1000 | appDate}}</p>
		</div>
	</div>
</ng-template>

<ng-template #shopCartCard>
	<div class="shop-card flex row space-between">
		<div class="content-shop-card flex row">
			<app-image customClass="radius-10" [imageResolutions]="[IMAGE_RESOLUTIONS.im, IMAGE_RESOLUTIONS.lg]" [src]="category?.image" alt="{{category?.name}}" placeholder="../../../assets/images/thumbnail.png" width="220px" height="124px" [fitCover]="true"></app-image>
			<div class="column shop-card-description">
				<h5 [title]="category?.name">{{ category?.name | truncate:20 }}</h5>
				<p>{{category?.author}}</p>
				<div class="row gap-16 flex start-center shop-card-cta-container">
					<h4>{{category?.currency?.label}}&nbsp;{{category?.price | currency:null:'symbol':'0.0-2' | truncate:20 }}</h4>
					<p class="pointer text-warn flex center gap-8" (click)="removeFromCart(category)">
						<mat-icon class="delete-icon" svgIcon="trash"></mat-icon>
						{{'general.delete' | translateWithKeys}}
					</p>

				</div>
			</div>
		</div>
		<div>

		</div>
	</div>
</ng-template>
